import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';
import { TooltipProvider } from './components/ui/tooltip';
import './index.css';
import { limparSessaoLegada } from './lib/auth/sessao-legada';
import './lib/i18n';
import { queryClient } from './lib/queryClient';
import { router } from './router';

limparSessaoLegada();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <TooltipProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </TooltipProvider>,
  );
}
